export default "__VITE_ASSET__B0vdTtV9__"